import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';

interface PopOverContentProperties {
  openPopover: boolean;
  popOverContent: JSX.Element | string;
}

const PopOverContent = forwardRef<HTMLDivElement, PopOverContentProperties>(function PopOverContent(
  { openPopover, popOverContent },
  popoverReference,
) {
  return openPopover
    ? ReactDOM.createPortal(
        <div className="pop-over-content-wrap">
          <div className="pop-over-content-container" ref={popoverReference}>
            {popOverContent}
          </div>
        </div>,
        document.body,
      )
    : null;
});

export default PopOverContent;
